import { useContext } from "react";
import { RegisterContext } from "./context";

export const useRegisterContext = () => {
  const c = useContext(RegisterContext);
  if (!c)
    throw new Error(
      "useRegisterContext cannot be used outside of a RegisterProvider"
    );
  return c;
};
